import { render, staticRenderFns } from "./ComplianceChart.vue?vue&type=template&id=1b290ea3"
import script from "./ComplianceChart.vue?vue&type=script&lang=ts"
export * from "./ComplianceChart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports